import { Col, Row } from "react-bootstrap";
import { getFormattedDateFromDbValue } from "../../../helper-functions/getFormattedDateFromDbValue";
import dentanet from "../../../images/id-cards/DentaNet.png";
import { cardWidth, cardHeight, ProductCategories, CardTemplateProps, getCoverage } from "../id-card-helpers";
import { alSealLogo, peehipLogo, visionChoiceLogo } from "../id-card-logos";

export default function PeehipIdCard({ memberBenefits }: CardTemplateProps) {
    const dentalCoverage = memberBenefits.find((d) => d.productCategory === ProductCategories.DENTAL);
    const visionCoverage = memberBenefits.find((d) => d.productCategory === ProductCategories.VISION);
    const cancerCoverage = memberBenefits.find((d) => d.productCategory === ProductCategories.CANCER);
    const indemnityCoverage = memberBenefits.find((d) => d.productCategory === ProductCategories.INDEMNITY);

    const { lastName, firstName, middleName } = memberBenefits[0];

    return (
        <div className="id-card">
            <div className="front" style={{ fontSize: "14px" }}>
                <div className="d-flex justify-content-between">
                    {alSealLogo}
                    <div style={{ fontWeight: 700, fontSize: "18px" }}>
                        Alabama Public Education
                        <br />
                        Employee Insurance Plan
                    </div>
                    {peehipLogo}
                </div>
                <div className="d-flex justify-content-between" style={{ fontSize: "11px" }}>
                    <div>
                        Name: {lastName.toUpperCase()}, {firstName.toUpperCase()} {middleName.toUpperCase()}
                        <br />
                        Contract Number: {memberBenefits[0].participantIDNumber}
                        <br />
                        Group Number: {memberBenefits[0].groupNumber}
                    </div>
                    <div className="d-flex flex-column">
                        {visionCoverage && visionChoiceLogo}
                        {dentalCoverage && (
                            <img
                                src={dentanet}
                                alt="DentaNet logo"
                                style={{
                                    maxHeight: cardHeight * 0.1,
                                    maxWidth: cardWidth * 0.2,
                                    height: "auto",
                                    width: "auto",
                                }}
                            />
                        )}
                    </div>
                </div>
                <Row>
                    <Col style={{ fontSize: "11px" }}>
                        <strong>Benefit</strong>
                        <br />
                        {!!dentalCoverage && (
                            <>
                                Dental
                                <br />
                            </>
                        )}
                        {!!visionCoverage && (
                            <>
                                Vision
                                <br />
                            </>
                        )}
                        {!!cancerCoverage && (
                            <>
                                Cancer
                                <br />
                            </>
                        )}
                        {!!indemnityCoverage && <>Indemnity</>}
                    </Col>
                    <Col style={{ fontSize: "11px" }}>
                        <strong>Coverage</strong>
                        <br />
                        {!!dentalCoverage && (
                            <>
                                {getCoverage(dentalCoverage.coverageOption)}
                                <br />
                            </>
                        )}
                        {!!visionCoverage && (
                            <>
                                {getCoverage(visionCoverage.coverageOption)}
                                <br />
                            </>
                        )}
                        {!!cancerCoverage && (
                            <>
                                {getCoverage(cancerCoverage.coverageOption)}
                                <br />
                            </>
                        )}
                        {!!indemnityCoverage && <>{getCoverage(indemnityCoverage.coverageOption)}</>}
                    </Col>
                    <Col style={{ fontSize: "11px" }}>
                        <strong>Effective Date</strong>
                        <br />
                        {dentalCoverage && (
                            <>
                                {getFormattedDateFromDbValue(dentalCoverage.memberProductEffectiveDate)}
                                <br />
                            </>
                        )}
                        {visionCoverage && (
                            <>
                                {getFormattedDateFromDbValue(visionCoverage.memberProductEffectiveDate)}
                                <br />
                            </>
                        )}
                        {cancerCoverage && (
                            <>
                                {getFormattedDateFromDbValue(cancerCoverage.memberProductEffectiveDate)}
                                <br />
                            </>
                        )}
                        {indemnityCoverage && (
                            <>{getFormattedDateFromDbValue(indemnityCoverage.memberProductEffectiveDate)}</>
                        )}
                        <br />
                    </Col>
                </Row>
                <Row>
                    <Col style={{ fontSize: "10px" }}>
                        This is your Optional Insurance Identification card. It becomes void if the contract is
                        terminated or if you cease to be covered under this program for any reason. A new card is not
                        issued each year.
                    </Col>
                </Row>
            </div>
            <div className="back" style={{ fontSize: "11px" }}>
                <p>
                    Plan Administered by:
                    <br />
                    <strong>
                        Southland Benefit Solutions, LLC
                        <br />
                        P.O. Box 1250
                        <br />
                        Tuscaloosa, Alabama 35403-1250
                    </strong>
                </p>
                <p>
                    Claims for services provided to the Primary Insured named on the front side of this card, or any
                    eligible dependents, should be sent directly to Southland Benefit Solutions.
                </p>
                <p>
                    The subscriber named on the front of this card and any dependents named on an application are
                    entitled to benefits as provided in the group contract.
                </p>
                <p>
                    For information about your benefits or eligibility information, visit www.southlandpeehip.com or
                    call 1-866-327-6674.
                </p>
            </div>
        </div>
    );
}
